import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Sidebar from './components/Sidebar';
import CustomersPage from './pages/CustomersPage';
import ProductsPage from './pages/ProductsPage';
import InvoicesPage from './pages/InvoicesPage';
import AzureInvoicePage from './pages/AzureInvoicePage';
import { SyncStatusPage, UsersPage, AuditLogPage, NotificationsPage } from './pages/OtherPages';

const DashboardLazy = lazy(() => import('./pages/Dashboard'));
const LoginPageLazy = lazy(() => import('./pages/LoginPage'));
const PricingLazy     = lazy(() => import('./pages/PricingPage'));
const AnalyticsLazy  = lazy(() => import('./pages/AnalyticsPage'));

function Layout({ children }) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg2)' }}>
      <Sidebar />
      <main style={{ flex: 1, marginLeft: 220, minHeight: '100vh', overflowY: 'auto' }}>
        {children}
      </main>
    </div>
  );
}

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'DM Sans, sans-serif', color: '#999' }}>
      Loading...
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Suspense fallback={null}><LoginPageLazy /></Suspense>} />
      <Route path="/" element={<RequireAuth><Suspense fallback={null}><DashboardLazy /></Suspense></RequireAuth>} />
      <Route path="/customers"     element={<RequireAuth><CustomersPage /></RequireAuth>} />
      <Route path="/products"      element={<RequireAuth><ProductsPage /></RequireAuth>} />
      <Route path="/invoices"      element={<RequireAuth><InvoicesPage /></RequireAuth>} />
      <Route path="/azure"         element={<RequireAuth><AzureInvoicePage /></RequireAuth>} />
      <Route path="/sync"          element={<RequireAuth><SyncStatusPage /></RequireAuth>} />
      <Route path="/notifications" element={<RequireAuth><NotificationsPage /></RequireAuth>} />
      <Route path="/audit"         element={<RequireAuth><AuditLogPage /></RequireAuth>} />
      <Route path="/users"         element={<RequireAuth><UsersPage /></RequireAuth>} />
      <Route path="/pricing"       element={<RequireAuth><Suspense fallback={null}><PricingLazy /></Suspense></RequireAuth>} />
      <Route path="/analytics"     element={<RequireAuth><Suspense fallback={null}><AnalyticsLazy /></Suspense></RequireAuth>} />
      <Route path="*"              element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
